module.exports = __webpack_public_path__ + "img/BE0830227057.92c40e50.svg";